import { logEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'

import { Link } from 'features/i18n/router'

export const HeaderTitle = ({ isLandingPage = false }) => {
  return (
    <Link
      to={ROUTE_PATH.HOME}
      onClick={() => {
        logEvent.navigation_pane_select({ destination: 'Home' })
      }}
    >
      <img
        className="HeaderTitle__logo"
        src={
          isLandingPage ? '/images/logotype-white.svg' : '/images/logotype.svg'
        }
        alt="yay! logo"
      />
    </Link>
  )
}
